import { PackingTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState } from "react";
import { MdClose, MdPrint } from "react-icons/md";
import { aging, packingEntryAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import PackingForm from "./PackingForm";
import { RegistryHeader, CalculationFooter, Button } from "../../common/Shared";
import { Info, Upload } from "lucide-react";
import { TourGuide } from "../../components/TourGuide/TourGuide";
import Model from "../../common/Model";

const Packing = () => {
  const getDiePdfUrl = (row) => {
    if (!row) return "";
    const pdfUrl = row.die_Pdf || row.diePdf || row.Die_Pdf;
    if (pdfUrl) return pdfUrl;

    const dieId = row.die_Id || row.dieId || row.Die_Id;
    if (dieId) {
      return `https://hline.blob.core.windows.net/hlinefiles/Extrusion/DieMedia/Pdf/${dieId}.pdf`;
    }
    return "";
  };

  const today = new Date().toISOString()?.split("T")[0];
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedPackingData, setSelectedPackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPackingData, setisPackingData] = useState([]);
  const [isAgingDoneData, setIsAgingDoneData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [formData, setFormData] = useState({
    packing_Date: today,
    packingDetails: [{
      bundle_No: "0",
      order_No: "",
      dieNumber: "",
      die_Id: "",
      batch_Id: "",
      casting_No: "",
      cut_Length: "",
      wt_12_FT: "",
      wt_Cut_Length: "",
      pcs: "",
      total_Weight: "",
      series_Name: "",
      remark: "",
      unit_Conv_Id: "",
      final_CutLength_weight: "",
      seq_No: "",
    }]
  });
  const pageSize = 50;
  const [isActiveTab, setIsActiveTab] = useState("aging-done");
  const [selectedAgingNo, setSelectedAgingNo] = useState(null);
  const [adding, setAdding] = useState(false);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const [savedBundles, setSavedBundles] = useState([]);
  const tableScrollRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [packingHasMore, setPackingHasMore] = useState(true);
  const [agingHasMore, setAgingHasMore] = useState(true);
  const [packingPage, setPackingPage] = useState(1);
  const [agingPage, setAgingPage] = useState(1);
  const [isPackingListModalOpen, setIsPackingListModalOpen] = useState(false);
  const [soldOutData, setSoldOutData] = useState([]);
  const [soldOutPage, setSoldOutPage] = useState(1);
  const [soldOutHasMore, setSoldOutHasMore] = useState(true);
  const [scannedBundles, setScannedBundles] = useState([]);
  const [vehicleNo, setVehicleNo] = useState("");
  const [currentBarcode, setCurrentBarcode] = useState("");
  const barcodeInputRef = useRef(null);

  const handleTourComplete = () => {
    localStorage.setItem("aluex_packing_tour_seen", "true");
  };

  const fetchPackingData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllPackingEntry(page, pageSize);
      setisPackingData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setPackingHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching sales order master data", "error");
    }
    setLoading(false);
  };

  const fetchSoldOutData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllSoldOutEntry(page, pageSize);
      setSoldOutData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setSoldOutHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching sold out data", "error");
    }
    setLoading(false);
  };

  const submitImport = async (e) => {
    e.preventDefault();
    if (!importFile) {
      notify("Please select a file to import", "warning");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", importFile);
    formData.append("userId", userId);

    try {
      await aging.agingDoneImport(formData);
      notify("Imported successfully", "success");
      setIsImportModalOpen(false);
      setImportFile(null);
      if (isActiveTab === "aging-done") fetchAgingDoneData();
    } catch (error) {
      notify(error?.response?.data?.message || "Failed to import file", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (row) => {
    const bundle_No = row?.bundle_No;
    setLoading(true);
    try {
      const res = await packingEntryAPI.getById(bundle_No);
      const doc = res?.data ?? res;
      setSelectedPackingData({
        packing_Date: doc.packing_Date || today,
        totalPcs: doc.totalPcs ?? 0,
        total_Weight: doc.total_Weight ?? 0,
        packingDetails: [doc]
      });
      setIsEditing(true);
      setIsModelOpen(true);
    } catch (err) {
      notify("Failed to fetch packing entry details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data) => {
    setIsSaving(true);
    try {
      if (!data.packingDetails || data.packingDetails.length === 0) {
        notify("Please add at least one row.", "warning");
        setIsSaving(false);
        return;
      }

      // Sum of pcs and total weight from row details
      const sumPcs = data.packingDetails.reduce((sum, row) => sum + Number(row.pcs || 0), 0);
      // const sumWeight = data.packingDetails.reduce((sum, row) => sum + parseFloat(row.total_Weight || 0), 0);

      const totalPcsAllowed = Number(data.totalPcs || 0);
      const totalWeightAllowed = parseFloat(data.total_Weight || 0);

      if (totalPcsAllowed > 0 && sumPcs > totalPcsAllowed) {
        notify(`Sum of Pcs (${sumPcs}) cannot exceed Total Pcs (${totalPcsAllowed})`, "error");
        setIsSaving(false);
        return;
      }

      // if (totalWeightAllowed > 0 ) {
      //   notify(`Sum of Total Weight (${sumWeight.toFixed(2)} KG) cannot exceed Total Weight (${totalWeightAllowed.toFixed(2)} KG)`, "error");
      //   setIsSaving(false);
      //   return;
      // }

      const payload = data.packingDetails.map((row) => ({
        bundle_No: String(row.bundle_No || "0"),
        packing_Date: data.packing_Date,
        order_No: Number(row.order_No || 0),
        die_Id: Number(row.die_Id || 0),
        cut_Length: parseFloat(row.cut_Length || 0),
        wT_12_FT: parseFloat(row.wt_12_FT || row.wT_12_FT || 0),
        wT_Cut_Length: parseFloat(row.wt_Cut_Length || row.wT_Cut_Length || 0),
        pcs: Number(row.pcs || 0),
        total_Weight: parseFloat(row.total_Weight || 0),
        series_Name: String(row.series_Name || ""),
        remark: String(row.remark || ""),
        created_By: Number(userId || 0),
        batch_Id: String(row.batch_Id || ""),
        casting_No: String(row.casting_No || ""),
        unit_Conv_Id: Number(row.unit_Conv_Id || 0),
        final_CutLength_weight: parseFloat(row.final_CutLength_weight || 0),
        seq_No: Number(row.seq_No || 0),
      }));

      const response = await packingEntryAPI.saveOrUpdateMultiple(payload);
      notify("Saved successfully", "success");

      const resultsArray = response?.results || (Array.isArray(response) ? response : []);
      const bundleNos = resultsArray.map((r) => r.bundle_No).filter(Boolean);

      setIsActiveTab("packing");
      setPackingPage(1);
      setAgingPage(1);
      fetchPackingData(1);
      fetchAgingDoneData(1);
      setIsModelOpen(false);
      setFormData({
        packing_Date: today,
        totalPcs: 0,
        total_Weight: 0,
        packingDetails: [{
          bundle_No: "0",
          order_No: "",
          dieNumber: "",
          die_Id: "",
          batch_Id: "",
          casting_No: "",
          cut_Length: "",
          wt_12_FT: "",
          wt_Cut_Length: "",
          pcs: "",
          total_Weight: "",
          series_Name: "",
          remark: "",
          unit_Conv_Id: "",
          final_CutLength_weight: "",
          seq_No: "",
        }]
      });
      setIsEditing(false);

      if (bundleNos.length > 0) {
        setSavedBundles(bundleNos);
        setPrintModalOpen(true);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const fetchAgingDoneData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllAgingDone(page, pageSize);
      setIsAgingDoneData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setAgingHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const handleTabChange = (tab) => {
    setIsActiveTab(tab);
    if (tab === "aging-done") {
      setPackingPage(1);
      setIsAgingDoneData([]);
      setAgingHasMore(true);
      setSoldOutPage(1);
    } else if (tab === "packing") {
      setPackingPage(1);
      setisPackingData([]);
      setPackingHasMore(true);
      setSoldOutPage(1);
    } else if (tab === "sold-out") {
      setSoldOutPage(1);
      setSoldOutData([]);
      setSoldOutHasMore(true);
      setPackingPage(1);
      setAgingPage(1);
    }
  };

  useEffect(() => {
    if (isActiveTab === "aging-done") fetchAgingDoneData(agingPage);
  }, [agingPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "packing") fetchPackingData(packingPage);
  }, [packingPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "sold-out") fetchSoldOutData(soldOutPage);
  }, [soldOutPage, isActiveTab]);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;

        if (isActiveTab === "aging-done" && agingHasMore) {
          setAgingPage((p) => p + 1);
        }

        if (isActiveTab === "packing" && packingHasMore) {
          setPackingPage((p) => p + 1);
        }

        if (isActiveTab === "sold-out" && soldOutHasMore) {
          setSoldOutPage((p) => p + 1);
        }
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [isActiveTab, loading, packingHasMore, agingHasMore, soldOutHasMore]);

  const columns = [
    {
      key: "select",
      align: "center",
      disableSort: true,
      label: <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Select</span>,
      render: (_v, row) => {
        const id = Number(row.seq_No);
        const isChecked = selectedAgingNo === id;
        return (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => setSelectedAgingNo(isChecked ? null : id)}
            className="w-4 h-4 text-primary cursor-pointer accent-primary"
          />
        );
      },
    },
    { key: "order_No", label: "ORDER NO", align: "center" },
    { key: "batch_Id", label: "BATCH NO", align: "center" },
    {
      key: "dieNumber",
      label: "DIE NO",
      align: "center",
      render: (val, row) => {
        const pdfUrl = getDiePdfUrl(row);
        return pdfUrl ? (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary font-black hover:underline cursor-pointer"
          >
            {val}
          </a>
        ) : (
          <span>{val}</span>
        );
      }
    },
    { key: "cut_Length", label: "CUT LENGTH", align: "center" },
    { key: "quantity", label: "PCS", align: "center" },
    { key: "pending_Pcs", label: "PENDING PCS", align: "center" },
    { key: "total_Weight", label: "TOTAL WEIGHT", align: "center" },
  ];

  const handleAddPacking = async () => {
    if (!selectedAgingNo) {
      notify("Please select one Aging-Done row.", "warning");
      return;
    }
    setAdding(true);
    try {
      const resp = await packingEntryAPI.AddToPacking(selectedAgingNo);
      const x = Array.isArray(resp) ? resp[0] : resp;
      const init = {
        packing_Date: x.packing_Date,
        totalPcs: x?.totalPcs ?? 0,
        total_Weight: x?.total_Weight ?? 0,
        packingDetails: [{
          bundle_No: "0",
          order_No: x?.order_No ?? "",
          die_Id: x?.die_Id ?? null,
          dieNumber: x?.dieNumber ?? "",
          cut_Length: x?.cut_Length ?? "",
          batch_Id: x?.batch_Id ?? "",
          casting_No: x?.casting_No ?? "",
          total_Weight: x?.total_Weight ?? "",
          wt_12_FT: "",
          wt_Cut_Length: x?.cut_Length ?? "",
          pcs: "",
          series_Name: x?.series_Name ?? "",
          remark: "",
          unit_Conv_Id: "",
          final_CutLength_weight: "",
          seq_No: x?.seq_No ?? selectedAgingNo ?? 0,
        }]
      };
      setSelectedPackingData(init);
      setIsModelOpen(true);
      setIsEditing(false);
      setSelectedAgingNo(null);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Packing",
        "error",
      );
    } finally {
      setAdding(false);
    }
  };

  const handlePrint = async () => {
    if (selectedBundles.length === 0) {
      notify("Please select at least one bundle to print", "warning");
      return;
    }

    setLoading(true);
    try {
      const payload = { bundleNos: selectedBundles };
      const res = await packingEntryAPI.packingBundles(payload);

      const blob = new Blob([res.data], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      notify("Failed to print selected bundles", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {loading && <Loader centered />}

      <RegistryHeader title="Packing Plan View">
        <button
          onClick={() => setIsTourOpen(true)}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Start Onboarding Tour"
        >
          <Info size={14} className="shrink-0" />
          Guide
        </button>
        <button
          onClick={() => setIsImportModalOpen(true)}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Import Data"
        >
          <Upload size={14} className="shrink-0" />
          Import
        </button>
        <div className="flex bg-gray-100 p-1 rounded-sm gap-1 shrink-0" data-tour="packing-tabs">
          <button
            onClick={() => handleTabChange("aging-done")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "aging-done"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Aging Done
          </button>
          <button
            onClick={() => handleTabChange("packing")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "packing"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Packing Entry
          </button>
          <button
            onClick={() => handleTabChange("sold-out")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "sold-out"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Sold Out
          </button>
        </div>
        {isActiveTab === "aging-done" ? (
          <Button
            disabled={adding}
            onClick={handleAddPacking}
            icon={HiOutlinePlus}
            className="whitespace-nowrap"
            loading={adding}
            data-tour="add-packing-btn"
          >
            {adding ? "INITIALIZING..." : `ADD Packing`}
          </Button>
        ) : isActiveTab === "packing" ? (
          <div className="flex gap-2">
            <button
              onClick={() => setIsPackingListModalOpen(true)}
              className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
            >
              Packing List
            </button>
            <Button
              onClick={handlePrint}
              disabled={selectedBundles.length === 0 || loading}
              icon={MdPrint}
              className="whitespace-nowrap"
              loading={adding}
              data-tour="print-sticker-btn"
            >
              {adding ? "INITIALIZING..." : `Print Sticker (${selectedBundles.length})`}
            </Button>
          </div>
        ) : null}
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col bg-white">
        <div
          ref={tableScrollRef}
          className="relative flex-1 overflow-auto border border-gray-200 bg-white"
          data-tour="packing-table"
        >
          {isActiveTab === "aging-done" && (
            <div className="min-w-max">
              <Table
                columns={columns}
                data={isAgingDoneData}
                showActions={false}
                onRowClick={(row) => {
                  const id = Number(row.seq_No);
                  setSelectedAgingNo((prev) => (prev === id ? null : id));
                }} tableClassName="text-[13px]"
              />
            </div>
          )}
          {isActiveTab === "packing" && (
            <div className="min-w-max bg-white">
              <Table
                columns={[
                  {
                    key: "select",
                    disableSort: true,
                    align: "center",
                    className: "w-12 border-r border-gray-100",
                    label: (
                      <input
                        type="checkbox"
                        checked={
                          isPackingData.length > 0 &&
                          isPackingData.every((row) => selectedBundles.includes(row.bundle_No))
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            const allIds = isPackingData.map((row) => row.bundle_No);
                            setSelectedBundles(allIds);
                          } else {
                            setSelectedBundles([]);
                          }
                        }}
                        className="w-4 h-4 text-primary cursor-pointer"
                      />
                    ),
                    render: (val, row) => (
                      <input
                        type="checkbox"
                        checked={selectedBundles.includes(row.bundle_No)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedBundles((prev) => [...prev, row.bundle_No]);
                          } else {
                            setSelectedBundles((prev) => prev.filter((id) => id !== row.bundle_No));
                          }
                        }}
                        className="w-4 h-4 text-primary cursor-pointer"
                      />
                    )
                  },
                  { key: "bundle_No", label: "BUNDLE NO", align: "center", className: "font-black text-gray-900 border-r border-gray-100" },
                  {
                    key: "dieNumber",
                    label: "DIE NO",
                    align: "left",
                    className: "font-black text-primary border-r border-gray-100",
                    render: (val, row) => {
                      const pdfUrl = getDiePdfUrl(row);
                      return pdfUrl ? (
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary font-black hover:underline cursor-pointer"
                        >
                          {val}
                        </a>
                      ) : (
                        <span>{val}</span>
                      );
                    }
                  },
                  { key: "series_Name", label: "SERIES", align: "left", className: "border-r border-gray-100 font-black text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "profile_Name", label: "PROFILE", align: "left", className: "border-r border-gray-100 text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "wt_Cut_Length", label: "FINAL CUT LENGHT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_Cut_Length || row.wT_Cut_Length },
                  { key: "unit_Conv_Name", label: "UNIT", align: "center", className: "text-gray-500 border-r border-gray-100 font-black text-[11px] uppercase tracking-widest" },
                  { key: "wt_12_FT", label: "WT/12 FT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_12_FT || row.wT_12_FT },
                  { key: "final_CutLength_Weight", label: "FINAL CUT LENGTH WT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter" },
                  {
                    key: "pcs",
                    label: "PCS",
                    align: "right",
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.pcs || row.pcs === 0 ? row.pcs : "-"}
                      </span>
                    )
                  },
                  {
                    key: "total_Weight",
                    label: "TOTAL WT",
                    align: "right",
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.total_Weight || row.total_Weight === 0 ? row.total_Weight : "-"}
                      </span>
                    )
                  },
                  {
                    key: "actions",
                    label: "ACTIONS",
                    align: "center",
                    render: (val, row) => (
                      <button
                        onClick={() => handleEdit(row)}
                        className="px-2.5 py-1 border border-gray-200 text-blue-600 hover:bg-blue-50 transition-all text-[10px] font-black uppercase tracking-wider rounded-none"
                      >
                        Edit
                      </button>
                    )
                  }
                ]}
                data={isPackingData}
                showActions={false}
                tableClassName="text-[13px] border-none"
              />
            </div>
          )}
          {isActiveTab === "sold-out" && (
            <div className="min-w-max bg-white">
              <Table
                columns={[
                  { key: "bundle_No", label: "BUNDLE NO", align: "center", className: "font-black text-gray-900 border-r border-gray-100" },
                  {
                    key: "dieNumber",
                    label: "DIE NO",
                    align: "left",
                    className: "font-black text-primary border-r border-gray-100",
                    render: (val, row) => {
                      const pdfUrl = getDiePdfUrl(row);
                      return pdfUrl ? (
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary font-black hover:underline cursor-pointer"
                        >
                          {val}
                        </a>
                      ) : (
                        <span>{val}</span>
                      );
                    }
                  },
                  { key: "series_Name", label: "SERIES", align: "left", className: "border-r border-gray-100 font-black text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "profile_Name", label: "PROFILE", align: "left", className: "border-r border-gray-100 text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "wt_Cut_Length", label: "FINAL CUT LENGHT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_Cut_Length || row.wT_Cut_Length },
                  { key: "unit_Conv_Name", label: "UNIT", align: "center", className: "text-gray-500 border-r border-gray-100 font-black text-[11px] uppercase tracking-widest" },
                  { key: "wt_12_FT", label: "WT/12 FT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_12_FT || row.wT_12_FT },
                  { key: "final_CutLength_Weight", label: "FINAL CUT LENGTH WT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter" },
                  {
                    key: "pcs",
                    label: "PCS",
                    align: "right",
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.pcs || row.pcs === 0 ? row.pcs : "-"}
                      </span>
                    )
                  },
                  {
                    key: "total_Weight",
                    label: "TOTAL WT",
                    align: "right",
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.total_Weight || row.total_Weight === 0 ? row.total_Weight : "-"}
                      </span>
                    )
                  }
                ]}
                data={soldOutData}
                showActions={false}
                tableClassName="text-[13px] border-none"
              />
            </div>
          )}
        </div>
      </div>

      {isModelOpen && formData && (
        <PackingForm
          initialData={selectedPackingData}
          onSave={handleSave}
          onCancel={() => setIsModelOpen(false)}
          isEditing={isEditing}
          filteredData={filteredData}
          formData={formData}
          setFormData={setFormData}
          isSaving={isSaving}
        />
      )}

      <Model
        isOpen={isImportModalOpen}
        onClose={() => {
          setIsImportModalOpen(false);
          setImportFile(null);
        }}
        name="Import Aging Done"
        widthClass="max-w-md"
      >
        <form onSubmit={submitImport} className="flex flex-col p-6 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
              Select File <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              accept=".xlsx,.xls,.csv"
              required
              onChange={(e) => setImportFile(e.target.files?.[0] || null)}
              className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors"
            />
          </div>

          <div className="flex justify-end gap-2 mt-4 pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={() => {
                setIsImportModalOpen(false);
                setImportFile(null);
              }}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50"
            >
              {loading ? "Importing..." : "Submit"}
            </button>
          </div>
        </form>
      </Model>
      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}

      <Model
        isOpen={isPackingListModalOpen}
        onClose={() => {
          setIsPackingListModalOpen(false);
          setScannedBundles([]);
          setVehicleNo("");
          setCurrentBarcode("");
        }}
        name="Generate Packing List"
        widthClass="max-w-2xl"
      >
        <div className="flex flex-col p-6 gap-4">
          <div className="flex gap-4">
            <div className="flex-1 flex flex-col gap-1">
              <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
                Scan Barcode
              </label>
              <input
                ref={barcodeInputRef}
                type="text"
                value={currentBarcode}
                onChange={(e) => setCurrentBarcode(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && currentBarcode.trim()) {
                    e.preventDefault();
                    if (!scannedBundles.includes(currentBarcode.trim())) {
                      setScannedBundles(prev => [...prev, currentBarcode.trim()]);
                    }
                    setCurrentBarcode("");
                  }
                }}
                placeholder="Scan or enter bundle no and press Enter"
                className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors"
                autoFocus
              />
            </div>
            <div className="flex-1 flex flex-col gap-1">
              <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
                Vehicle No <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={vehicleNo}
                onChange={(e) => setVehicleNo(e.target.value)}
                placeholder="Enter Vehicle No"
                className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors uppercase"
              />
            </div>
          </div>

          <div className="mt-2 border border-gray-200 rounded-sm overflow-hidden flex flex-col" style={{ minHeight: '200px' }}>
            <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 text-[11px] font-black text-gray-600 uppercase tracking-wider flex justify-between">
              <span>Scanned Bundles ({scannedBundles.length})</span>
              {scannedBundles.length > 0 && (
                <button onClick={() => setScannedBundles([])} className="text-red-500 hover:text-red-700 font-bold text-[10px]">Clear All</button>
              )}
            </div>
            <div className="flex-1 overflow-y-auto p-4 bg-slate-50 flex flex-wrap gap-2 items-start content-start">
              {scannedBundles.map((b, idx) => (
                <div key={idx} className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 text-primary font-mono text-[13px] font-black tracking-tight group">
                  {b}
                  <MdClose
                    className="cursor-pointer text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                    onClick={() => setScannedBundles(prev => prev.filter(item => item !== b))}
                  />
                </div>
              ))}
              {scannedBundles.length === 0 && (
                <div className="text-gray-400 text-sm w-full text-center py-8">No bundles scanned yet</div>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-4 pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={() => {
                setIsPackingListModalOpen(false);
                setScannedBundles([]);
                setVehicleNo("");
                setCurrentBarcode("");
              }}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={loading || scannedBundles.length === 0 || !vehicleNo.trim()}
              onClick={async () => {
                setLoading(true);
                try {
                  const payload = {
                    bundleNos: scannedBundles,
                    vehicleNo: vehicleNo.trim()
                  };
                  const res = await packingEntryAPI.generatePackingList(payload);

                  const blob = new Blob([res.data], { type: "application/pdf" });
                  const pdfUrl = URL.createObjectURL(blob);
                  window.open(pdfUrl, "_blank");

                  notify("Packing list generated successfully", "success");
                  setIsPackingListModalOpen(false);
                  setScannedBundles([]);
                  setVehicleNo("");
                  setCurrentBarcode("");
                  fetchPackingData()
                } catch (error) {
                  notify(error?.response?.data?.message || "Failed to generate packing list", "error");
                } finally {
                  setLoading(false);
                }
              }}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50 flex gap-2 items-center"
            >
              {loading ? "Generating..." : "Save & Generate"}
            </button>
          </div>
        </div>
      </Model>

      <Model
        isOpen={printModalOpen}
        onClose={() => setPrintModalOpen(false)}
        name="Print Bundle"
        widthClass="max-w-md"
      >
        <div className="flex flex-col p-6 gap-5">
          <div className="flex flex-col gap-2.5 text-center">
            <div className="w-12 h-12 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center mx-auto mb-2">
              <MdPrint size={24} />
            </div>
            <h3 className="text-sm font-black text-gray-800 uppercase tracking-wider">
              Do you want to print the stickers?
            </h3>
            <div className="flex flex-wrap gap-1.5 justify-center max-h-36 overflow-y-auto bg-slate-50 p-3 border border-slate-100/80 rounded-none">
              {savedBundles.map((b, idx) => (
                <span
                  key={idx}
                  className="px-2.5 py-1 bg-white border border-gray-200 text-primary font-mono text-[11px] font-black tracking-tight"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>

          <div className="flex justify-center gap-3 mt-4 pt-4 border-t border-slate-100">
            <button
              onClick={() => setPrintModalOpen(false)}
              className="px-5 py-2.5 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors rounded-none w-28"
            >
              No
            </button>
            <button
              onClick={async () => {
                setPrintModalOpen(false);
                setLoading(true);
                try {
                  const payload = { bundleNos: savedBundles };
                  const res = await packingEntryAPI.packingBundles(payload);
                  const blob = new Blob([res.data], { type: "application/pdf" });
                  const pdfUrl = URL.createObjectURL(blob);
                  window.open(pdfUrl, "_blank");
                } catch (error) {
                  notify("Failed to print selected bundles", "error");
                } finally {
                  setLoading(false);
                }
              }}
              className="px-5 py-2.5 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors rounded-none w-28 shadow-sm"
            >
              Yes
            </button>
          </div>
        </div>
      </Model>


      <div data-tour="packing-footer">
        <CalculationFooter
          items={[
            isActiveTab === 'packing' && {
              label: "Selected Rows",
              value: isActiveTab === 'packing' ? selectedBundles.length : 0,
              suffix: "Rows",
              color: "text-green-500"
            },
            (isActiveTab === 'packing' || isActiveTab === "aging-done") && {
              label: "Selected Units",
              value: isActiveTab === 'packing'
                ? isPackingData
                  .filter((row) => selectedBundles.includes(row.bundle_No))
                  .reduce((sum, row) => sum + (Number(row.pcs) || 0), 0)
                  .toLocaleString()
                : isAgingDoneData
                  .filter((row) => Number(row.seq_No) === selectedAgingNo)
                  .reduce((sum, row) => sum + (Number(row.quantity) || 0), 0)
                  .toLocaleString(),
              suffix: "PCS",
              color: "text-primary"
            }, (isActiveTab === 'packing' || isActiveTab === "aging-done") && {
              label: "Selected Weight",
              value: isActiveTab === 'packing'
                ? isPackingData
                  .filter((row) => selectedBundles.includes(row.bundle_No))
                  .reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0)
                  .toFixed(3)
                : isAgingDoneData
                  .filter((row) => Number(row.seq_No) === selectedAgingNo)
                  .reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0)
                  .toFixed(3),
              suffix: "KG",
              color: "text-primary"
            }, {
              label: "Total Units",
              value: isActiveTab === 'packing'
                ? isPackingData.reduce((sum, row) => sum + (Number(row.pcs) || 0), 0).toLocaleString()
                : isActiveTab === 'sold-out'
                  ? soldOutData.reduce((sum, row) => sum + (Number(row.pcs) || 0), 0).toLocaleString()
                  : isAgingDoneData.reduce((sum, row) => sum + (Number(row.quantity) || 0), 0).toLocaleString(),
              suffix: "PCS"
            },
            {
              label: "Total Weight",
              value: isActiveTab === 'packing'
                ? isPackingData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3)
                : isActiveTab === 'sold-out'
                  ? soldOutData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3)
                  : isAgingDoneData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3),
              suffix: "KG",
              color: "text-black"
            },


          ].filter(Boolean)}
        />
      </div>

      <TourGuide
        isOpen={isTourOpen}
        steps={PackingTourSteps}
        title="Packing Guide"
        model="Packing Module"
        onClose={() => {
          setIsTourOpen(false);
          handleTourComplete();
        }}
      />
    </div>

  );
};

export default Packing;
